module.exports = __webpack_public_path__ + "img/google-play-badge.d17ac293.png";